/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SuspensionInputs */

const en__field_suspension = /** @type {(inputs: _Field_SuspensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspension`)
};

const de__field_suspension = /** @type {(inputs: _Field_SuspensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspendierung`)
};

/**
* | output |
* | --- |
* | "Suspension" |
*
* @param {_Field_SuspensionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_suspension = /** @type {((inputs?: _Field_SuspensionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SuspensionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_suspension(inputs)
	return de__field_suspension(inputs)
});